import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BackgroundImageService {

  private backgroundImage: string = '';

  constructor() { }

  randonImage(): string {
    const imgs = environment.igmsbackgroundlogin;
    const random = Math.floor(Math.random() * imgs.length);

    this.backgroundImage = imgs[random];

    return this.backgroundImage;
  }

  getBackgroundImage(): string {
    return this.backgroundImage;
  }
}
